// this is an autogenerated file from App/Account/Content/Tasks/mutation-create-task.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks(
  $board_id: uuid!
  $location_id: uuid!
  $stage_id: uuid!
  $title: String!
  $description: String
  $order: numeric!
  $priority: tasks_priorities_enum!
  $due_date: timestamp
  $resource_schema: String
  $resource_table: String
  $resource_id: uuid
  $assignees: [tasks_assignees_insert_input!]!
  $task_tags: [tasks_tasks_tags_insert_input!]!
  $resources: [tasks_resources_insert_input!]!
) {
  insert_tasks_tasks_one(
    object: {
      board_id: $board_id
      location_id: $location_id
      stage_id: $stage_id
      title: $title
      description: $description
      order: $order
      priority: $priority
      due_date: $due_date
      resource_schema: $resource_schema
      resource_table: $resource_table
      resource_id: $resource_id
      assignees: { data: $assignees }
      task_tags: { data: $task_tags }
      resources: { data: $resources }
    }
  ) {
    id
  }
}

`